import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "currentColor",
      "stroke-width": "1.1"
    }, [
      _createElementVNode("path", {
        d: "M3.9 12 2.4 9.3c-.5-.8-.5-1.8 0-2.6L3.9 4c.5-.8 1.4-1.3 2.3-1.3h3.6c1 0 1.8.5 2.3 1.3l1.5 2.7c.5.8.5 1.8 0 2.6L12.1 12c-.5.8-1.4 1.3-2.3 1.3H6.2c-1 0-1.8-.5-2.3-1.3z",
        "clip-rule": "evenodd"
      }),
      _createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "m6.3 9.7 3.4-3.4m0 3.4L6.3 6.3"
      })
    ], -1)
  ])))
}
export default { render: render }